import { defineComponent, h } from "vue";

export const UiProgressBar = defineComponent({
  name: "ProgressBar",
  setup() {
    return () => h("div", { class: "h-2 overflow-hidden rounded-full bg-slate-200" }, [
      h("div", { class: "h-full w-1/2 animate-pulse rounded-full bg-teal-600" }),
    ]);
  },
});

export const UiProgressSpinner = defineComponent({
  name: "ProgressSpinner",
  setup() {
    return () => h("div", { class: "h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600" });
  },
});

export const UiConfirmDialog = defineComponent({ name: "ConfirmDialog", setup: () => () => null });
export const UiConfirmPopup = UiConfirmDialog;

export const UiMessage = defineComponent({
  name: "Message",
  setup: (_, { slots }) => () => h("div", { class: "rounded-lg border border-teal-200 bg-teal-50 p-3 text-sm text-teal-900" }, slots.default?.()),
});
